/**
 * @desc 完成审批任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(
  body: defs.activiti.ApprovalConditionRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/financeApprovalFacade/batchCompleteTask`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
